export default __webpack_public_path__ + "static/media/Zip_file.35ead374.svg";